import {isFunction} from 'lodash/fp';
import {NextRouter} from 'next/router';

import {DefaultRedirectTarget, RedirectTarget} from './useReturnUrl.types';

export const resolveRedirectUrl = async (
  target: RedirectTarget,
  defaultTarget: DefaultRedirectTarget,
): Promise<string | null> => {
  let url: string | null;

  let resolvedDefaultTarget: string | null;
  if (isFunction(defaultTarget)) {
    resolvedDefaultTarget = await defaultTarget();
  } else {
    resolvedDefaultTarget = defaultTarget;
  }

  if (target === true) {
    url = resolvedDefaultTarget;
  } else if (target === false) {
    url = null;
  } else if (isFunction(target)) {
    url = await target(resolvedDefaultTarget);
  } else {
    url = target;
  }

  return url;
};

type RedirectToUrlOptions = {
  forcePageLoad?: boolean;
};

export const handleRedirectToUrl = async (
  router: NextRouter,
  target: RedirectTarget,
  defaultTarget: DefaultRedirectTarget,
  options?: RedirectToUrlOptions,
): Promise<boolean> => {
  const url = await resolveRedirectUrl(target, defaultTarget);

  if (url) {
    if (options?.forcePageLoad) {
      window.location.href = url;
      return true;
    } else {
      if (url.match(/^\//)) {
        return router.push(url);
      } else {
        window.location.href = url;
        return true;
      }
    }
  } else {
    return false;
  }
};
